// extracted by mini-css-extract-plugin
export default {"root":"BreadcrumbsRow-module--root--8a93e"};